import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon, MinusIcon } from '@heroicons/react/solid';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';
import { styled } from '../stitches.config';
const StyledRoot = styled(CheckboxPrimitive.Root, {
    all: 'unset',
    backgroundColor: 'white',
    width: 16,
    height: 16,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid $gray-300',
    '&:focus': {
        outline: '1px solid $primary-300',
        outlineOffset: 2,
    },
    '&:disabled': {
        backgroundColor: '$gray-200',
    },
});
const Indicator = styled(CheckboxPrimitive.Indicator, {
    color: 'white',
    lineHeight: 0,
});
export const Checkbox = React.forwardRef(function Checkbox(props, ref) {
    return (_jsx(StyledRoot, { ...props, css: props.checked === true
            ? {
                backgroundColor: '$primary-600',
                borderColor: '$primary-600',
            }
            : undefined, ref: ref, children: _jsxs(Indicator, { children: [props.checked === 'indeterminate' && (_jsx(DashIcon, { width: 16, height: 16 })), props.checked === true && _jsx(CheckIcon, { width: 16, height: 16 })] }) }));
});
const DashIcon = styled(MinusIcon, {
    color: '$primary-500',
});
//# sourceMappingURL=checkbox.js.map